module.exports = {"apiName":"PROD Admin API","apiUrl":"https://admin-api.osano.com"};